export default {
  width: 24,
  height: 27,
  svg: `
  <path d="M22.5221 24.75L22.5197 24.7487V2.31879L14.4833 0L0.0362618 5.42464L0 5.43163L0.00174756 21.6501L4.93183 19.7205V6.52495L14.4833 4.24132L14.482 23.6423L0.00983002 21.6501L14.482 26.9941V27L22.5197 24.7756V24.75H22.5221Z"/>`
}
